import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import axios from 'axios';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {AuthContextProvider} from "./context/AuthContext";
import {LanguageProvider} from "./context/LanguageContext";

import {ReactKeycloakProvider} from "@react-keycloak/web";
import my_keycloak from "./Keycloak"

// NEW CODE START
const apiBaseUrl = process.env.REACT_APP_API_URL;
if (apiBaseUrl) {
    axios.defaults.baseURL = apiBaseUrl;
}

// Centralize Keycloak token refresh/attachment so every request goes through
// a single, sequential path instead of each component racing its own
// updateToken() call (which was the source of the white-screen crash on
// client-side route transitions).
axios.interceptors.request.use(async (config) => {
    if (my_keycloak.authenticated) {
        await my_keycloak.updateToken(30);
        config.headers.Authorization = `Bearer ${my_keycloak.token}`;
    }
    return config;
});
// NEW CODE END

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <ReactKeycloakProvider authClient={my_keycloak} initOptions={{onLoad: 'login-required'}}>
        <React.StrictMode>
            <BrowserRouter>
                <LanguageProvider>
                    <AuthContextProvider>
                        <Routes>
                            <Route path={'/*'} element={<App/>}/>
                        </Routes>
                    </AuthContextProvider>
                </LanguageProvider>
            </BrowserRouter>
        </React.StrictMode>
    </ReactKeycloakProvider>);

reportWebVitals();
